import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "popup-contents" }
const _hoisted_2 = { class: "popup-contents-title" }
const _hoisted_3 = { class: "popup-contents-text" }


import Modal from "@/views/base/ModalComponent.vue";

// ---- props ----------------------------------------

export default /*@__PURE__*/_defineComponent({
  __name: 'TreatmentTips',
  props: {
    span: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// 閉じるボタン押下時処理
function onClose() {
  emit("close");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    id: "generalpurpose03-00-modal",
    modalClass: "my-report-popup",
    showTab: false,
    onClose: onClose
  }, {
    bodyInfo: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("img", {
          class: "popup-contents-img",
          src: "/server/necs/images/my_report_popup.png"
        }, null, -1)),
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("myreport_treatment_title", { span: props.span })), 1),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("myreport_treatment_message_intro", { span: props.span })), 1)
      ])
    ]),
    footerButton: _withCtx(() => [
      _createElementVNode("button", {
        class: "modal-ok",
        onClick: onClose
      }, _toDisplayString(_ctx.$t("myreport_treatment_button_close")), 1)
    ]),
    _: 1
  }))
}
}

})